const initialState = {
  blogs: [],
  adminBlogs: [],
  EductionVideos: [],
  lastDocument: "",
  hasMoreDocument: true,
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ADMIN_BLOGS":
      return {
        ...state,
        adminBlogs: action.payload,
      };
    case "EDUCTION_VIDEOS":
      return {
        ...state,
        EductionVideos: action.payload,
      };
    case "BLOGDETAILS":
      return {
        ...state,
        blogs: action.payload.data,
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MOREBLOGDETAILS":
      return {
        ...state,
        blogs: [...state.blogs, ...action.payload.data],
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "ADD_BLOG_DATA":
      return {
        ...state,
        blogs: [...state.blogs, action.payload],
      };
    case "EDIT_BLOG_DATA":
      return {
        ...state,
        blogs: state.blogs.map((data) =>
          data.id === action.payload.editingBlogId
            ? { ...data, ...action.payload.blogData }
            : data
        ),
      };
    case "DELETE_BLOG_DATA":
      return {
        ...state,
        blogs: state.blogs.filter((data) => {
          return data.id !== action.payload;
        }),
      };

    default:
      return state;
  }
};
export default blogReducer;
